module.exports = __webpack_public_path__ + "static/media/sample_patient.53617a2f.csv";